import styled from 'styled-components';
import { Button } from 'antd';

export const TableContainer = styled.div`
  position: relative;
  display: inline-block;
  max-width: 100%;
  overflow-x: auto;
`;

export const StyledTable = styled.table`
  border-collapse: collapse;
  width: auto;
`;

export const DownloadButton = styled(Button)`
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: rgb(255 255 255 / 90%);
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 10%);
  z-index: 1000;
  padding: 4px 8px;
  height: auto;
  min-height: 24px;
`;
